import { registerComponent } from '@gig/magic-common';
import FormBuilderComponent from './form-builder.vue.js';

var FormBuilder = registerComponent(FormBuilderComponent, false);

export { FormBuilder };
